import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.match";
var canUseWebP = typeof document === 'undefined' ? false : document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') === 0;
var REG_EXP = /\.(\w+)(\/\d+)?$/;
var DEFAULT_EXT = 'png';
export default {
  name: 'VftVipIcon',
  props: {
    payVip: {
      type: Object,
      required: true
    },
    useShort: {
      type: Boolean,
      default: false
    },
    useYearIcon: {
      type: Boolean,
      default: true
    },
    useNum: {
      type: Boolean,
      default: true
    },
    iclass: {
      type: Object
    },
    ext: {
      type: String
    },
    type: {
      type: String
    }
  },
  data: function data() {
    return {
      isFallback: false
    };
  },
  computed: {
    // 等级的角标class
    levelClass: function levelClass() {
      var value = {};

      if (this.useShort || this.payVip.level === 0) {
        value['icon_vip_lv' + this.payVip.level] = true;

        if (!this.payVip.vip) {
          // 过期会员
          value.icon_vip_grey = true;
        }
      } else {
        value['icon_vip_lv' + this.payVip.level] = true; // 年费会员

        if (this.useYearIcon) {
          value['icon_vipyear'] = true;

          if (!this.payVip.annualvip) {
            value['icon_yearvip_grey'] = true;
          }

          if (!this.payVip.vip) {
            value['icon_vip_grey'] = true;
          }
        } else {
          value['icon_vip_l'] = true;

          if (!this.payVip.vip) {
            value['icon_vip_grey'] = true;
          }
        }
      }

      return Object.assign({}, value, this.iclass);
    },
    originIconUrl: function originIconUrl() {
      var iconUrl = '';

      if (this.payVip) {
        var iconData = this.payVip["".concat(this.type || 'composite', "_icon")];
        iconUrl = iconData && iconData.icon_url;
      }

      return iconUrl;
    },
    originExt: function originExt() {
      if (!this.originIconUrl) {
        return '';
      }

      var matches = this.originIconUrl.match(REG_EXP);
      return matches && matches[1] || '';
    },
    iconUrl: function iconUrl() {
      if (!this.originIconUrl) {
        return '';
      }

      var ext = this.ext || (!canUseWebP && this.originExt === 'webp' ? DEFAULT_EXT : '');

      if (this.isFallback || !ext) {
        return this.originIconUrl;
      }

      return this.originIconUrl.replace(REG_EXP, ".".concat(ext, "$2"));
    },
    useNewIcon: function useNewIcon() {
      return !this.useShort && this.originIconUrl;
    },
    isCompat: function isCompat() {
      return this.type === 'vip' && this.payVip && this.payVip.level < 8;
    }
  }
};